export default "__VITE_ASSET__2b9880c7__"